import { RecalProposalSetConstant, recalProposalSetRequiredFieldList } from "presentation/constant/RecalProposalSet/RecalProposalSetConstant";
import { useRecalProposalSetVM } from "presentation/hook/RecalProposalSet/useRecalProposalSetVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { RecalProposalSetModel } from "presentation/model/RecalProposalSet/RecalProposalSetModel";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { NbisIconButton } from "presentation/view/components/NbisIconButton";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHBreadcrumb, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { Breadcrumb, SidebarCaption, Sidebarheader, SidebarTitle, StyledAction, StyledSidebar } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const RecalProposalSetEditPanel = ({ recalProposalSetState }: { recalProposalSetState: RecalProposalSetModel }) => {
    const RECAL_PROPOSAL_SET_CONSTANT = RecalProposalSetConstant.Table;
    const [isLoading, setIsLoading] = useState(false);
    const recalProposalSetVM = useRecalProposalSetVM();
    const [anaInfoState] = useANAInfoTracked();
    const { allowUpdate } = anaInfoState;
    const { currentRow, currentEditRow, isAdd, isEdit, isShowDtlAddPanel, isShowDtlEditPanel, masterState } = recalProposalSetState;
    const { isSaveClicked, allFormState } = masterState;
    const messageBarVM = useMessageBarVM();
    const panelRow = (isEdit || isAdd) ? currentEditRow : currentRow;

    const handleSave = useCallback(async () => {
        // if (!panelRow.proposalSetName) {
        //     messageBarVM.showError("Proposal Set Name is mandatory.");
        //     return;
        // }

        setIsLoading(true);
        recalProposalSetVM.onSaveClicked();
        const data = await recalProposalSetVM.onSave(panelRow);
        if (data && data.success) {
            messageBarVM.showSuccess("Save Successfully.");
            recalProposalSetVM.searchAllRecalProposalSetList().then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        } else {
            setIsLoading(false)
            data.data && messageBarVM.showError(data.data);
            return;
        }
    }, [recalProposalSetVM, panelRow, messageBarVM]);

    const handClose = useCallback(() => {
        recalProposalSetVM.onCloseEidtPanel();
    }, [recalProposalSetVM]);

    const memoProposalSetName = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "270px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={false}
                readOnlyValue={panelRow?.proposalSetName ?? ''}
                fieldValue={panelRow?.proposalSetName}
                fieldLabel={RECAL_PROPOSAL_SET_CONSTANT.PROPOSAL_SET_NAME}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXT}
                fieldKey={'proposalSetName'}
                maxLength={20}
                requiredFieldList={recalProposalSetRequiredFieldList}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    recalProposalSetVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, panelRow?.proposalSetName, RECAL_PROPOSAL_SET_CONSTANT.PROPOSAL_SET_NAME, isSaveClicked, recalProposalSetVM])

    const memoProposalSetDesc = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "500px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={!(isAdd || isEdit)}
                isShowOptional={true}
                readOnlyValue={panelRow?.proposalSetDesc ?? ''}
                fieldValue={panelRow?.proposalSetDesc}
                fieldLabel={RECAL_PROPOSAL_SET_CONSTANT.PROPOSAL_SET_DESC}
                isSaveClicked={isSaveClicked}
                fieldType={FieldType.TEXTAREA}
                fieldKey={'proposalSetDesc'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    recalProposalSetVM.onHeaderFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, isAdd, isEdit, panelRow?.proposalSetDesc, RECAL_PROPOSAL_SET_CONSTANT.PROPOSAL_SET_DESC, isSaveClicked, recalProposalSetVM])

    const handleEdit = useCallback(() => {
        recalProposalSetVM.onEditClick();
    }, [recalProposalSetVM]);

    const handleReset = useCallback(() => {
        recalProposalSetVM.onResetClick(isAdd);
    }, [recalProposalSetVM, isAdd]);


    return <>
        <StyledSidebar style={{ width: '100%', height: "100%", border: 'none', backgroundColor: '#FFFFFF', overflow: 'auto', padding: '0' }} position='right'>
            <Sidebarheader style={{ width: '100%' }}>
                {isLoading && <Loader Indicator="Spinner" size="Medium" />}
                <Breadcrumb>
                    <HPHBreadcrumb breadcrumbData={[{ title: RecalProposalSetConstant.Title.CATEGORY },
                    { title: RecalProposalSetConstant.Title.TITLE }]} onCurrentClick={() => { }}>
                    </HPHBreadcrumb>
                </Breadcrumb>
                <StyledAction>
                    <>
                        {allowUpdate && (!(isAdd || isEdit)) && <NbisIconButton fileName='Icon-pen' size='medium' disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Edit'} onClick={handleEdit} />}
                        {(isAdd || isEdit) && <IconButton fileName="Icon-reset" size="medium" disabled={false} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Reset'} onClick={() => handleReset()} />}

                        <IconButton fileName="Icon-cross" size="medium" disabled={(isShowDtlAddPanel || isShowDtlEditPanel)} toolTipArrow={false} toolTipPlacement='bottom' toolTipText={'Close'} onClick={() => handClose()} />
                        {(isAdd || isEdit) && <IconButton fileName="Icon-tick" size="medium" disabled={(isShowDtlAddPanel || isShowDtlEditPanel)} toolTipArrow={false} toolTipPlacement="bottom" toolTipText={'Save'} onClick={() => handleSave()} />}
                    </>
                </StyledAction>
            </Sidebarheader>

            <div className={'add-edit-form'} style={{ height: 'calc(100vh - 125px)', maxHeight: 'calc(100vh - 125px)', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <div className={'im-flex-row'}>
                            <div className={'flex-row-item-stretch'}>
                                <SidebarTitle>
                                    {isAdd && "New Proposal Set"}
                                    {!isAdd && (panelRow.proposalSetName)}
                                </SidebarTitle>
                                {<SidebarCaption>"All fields are required unless indicated as 'optional'"</SidebarCaption>}
                            </div>
                        </div>

                        <CriteriaItemContainer>
                            {memoProposalSetName}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoProposalSetDesc}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>
        </StyledSidebar>
    </>
}

export default memo(RecalProposalSetEditPanel);
